export default __webpack_public_path__ + "static/media/FarmingPlant Delayed.9ff440f2.wav";